import { useInvoslyLang } from '@/lib/i18n';
import { useDocSeoSync } from '@/lib/seo';
import { Nav } from '@/ui/Nav';
import { Footer } from '@/ui/Footer';
import { FinalCTA } from '@/ui/FinalCTA';
import { I18N } from './i18n';
import {
  Hero, TrustStrip, KeyBenefits, HowItWorks, FeatureHighlights, FAQ,
} from './sections';

export function Page() {
  const [lang] = useInvoslyLang();
  const dict = I18N[lang];
  useDocSeoSync({ lang, title: dict.page_title, desc: dict.page_desc });
  return (
    <div>
      <Nav
        active="home"
        labels={{
          home: dict.nav_home,
          product: dict.nav_product,
          signin: dict.nav_signin,
          signup: dict.nav_signup,
        }}
      />
      <main>
        <Hero t={dict} />
        <TrustStrip t={dict} />
        <KeyBenefits t={dict} />
        <HowItWorks t={dict} />
        <FeatureHighlights t={dict} />
        <FAQ t={dict} />
        <FinalCTA title={dict.cta_title} sub={dict.cta_sub} btn={dict.cta_btn} />
      </main>
      <Footer
        labels={{
          tagline: dict.foot_tag,
          productHeader: dict.foot_product,
          productLinks: dict.foot_links_p,
          companyHeader: dict.foot_company,
          companyLinks: dict.foot_links_c,
          helpHeader: dict.foot_help,
          helpLinks: dict.foot_links_h,
          legal: dict.foot_legal,
          copyright: dict.foot_copy,
        }}
      />
    </div>
  );
}
